module.exports = __webpack_public_path__ + "static/media/address-icon.0b22a41d.svg";